export default __webpack_public_path__ + "static/char-v-12-116851eed2e906b6d08d09cd015019d1.webp";